export const products = {
  // Main Products Page
  mainHero: {
    title: "Our Products",
    subtitle: "Discover our premium selection of coffee, tea, and beverage solutions"
  },

  // Coffee Section
  coffee: {
    title: "ROASTED COFFEE",
    description: "Premium roasted coffee beans sourced from the finest origins",
    button: "Explore Coffee"
  },

  // Milkshakes Section
  milkshakes: {
    title: "MILKSHAKES",
    description: "Delicious and creamy milkshake mixes for every taste",
    button: "Explore Milkshakes"
  },

  // HoReCa Section
  horeca: {
    title: "HORECA SOLUTIONS",
    description: "Professional products for hotels, restaurants, and cafés",
    button: "Explore HoReCa"
  },

  // Tea Section
  tea: {
    title: "TEA",
    description: "Premium tea selection",
    button: "Explore Tea",
    comingSoon: "Coming Soon"
  },

  // Machines Section
  machines: {
    title: "COFFEE & TEA MACHINES",
    description: "Professional brewing equipment",
    button: "Explore Machines",
    comingSoon: "Coming Soon"
  },

  // Roasted Coffee Page
  roastedCoffee: {
    hero: {
      title: "Roasted Coffee",
      subtitle: "Premium coffee beans roasted to perfection",
      label: "COFFEE COLLECTION"
    },
    intro: {
      title: "Artisan Roasted Excellence",
      description: "Our roasted coffee collection represents the pinnacle of coffee craftsmanship. Each bean is carefully selected from the world's finest coffee-growing regions and roasted to perfection, bringing out unique flavor profiles that coffee enthusiasts cherish."
    },
    seeDetails: "See Details"
  },

  // Pods Page
  pods: {
    hero: {
      title: "Coffee Pods",
      subtitle: "Convenient single-serve coffee solutions",
      label: "ESE 44MM PODS"
    },
    intro: {
      title: "Perfect Coffee, Every Time",
      description: "Our coffee pods deliver consistent quality and convenience. Each pod is carefully crafted to preserve the rich flavors and aromas of freshly roasted coffee, making it easy to enjoy a perfect cup every time."
    },
    seeDetails: "See Details"
  },

  // Capsules Page
  capsules: {
    hero: {
      title: "Compatible Capsules",
      subtitle: "Premium capsules for your coffee machine",
      label: "COMPATIBLE CAPSULES"
    },
    intro: {
      title: "Compatibility Meets Quality",
      description: "Our compatible capsules are designed to work seamlessly with popular coffee machines while delivering exceptional taste. Experience premium coffee without compromise."
    },
    seeDetails: "See Details"
  },

  // Milkshakes Page
  milkshakesPage: {
    hero: {
      title: "Milkshakes",
      subtitle: "Creamy and delicious milkshake mixes",
      label: "MILKSHAKE COLLECTION"
    },
    intro: {
      title: "Indulgent Milkshake Experience",
      description: "Our milkshake collection offers a variety of rich, creamy flavors that delight customers of all ages. Perfect for cafés, restaurants, and ice cream parlors."
    },
    seeDetails: "See Details"
  },

  // HoReCa Page
  horecaPage: {
    hero: {
      title: "HoReCa Solutions",
      subtitle: "Professional products for the hospitality industry",
      label: "PROFESSIONAL SOLUTIONS"
    },
    intro: {
      title: "Elevate Your Culinary Creations",
      description: "Our HoReCa range is specifically designed for professional use in hotels, restaurants, and cafés. From pralines to sauces, each product meets the highest standards of quality and consistency."
    },
    categories: {
      pralines: "Pralines",
      fillingCreams: "Filling Creams",
      fillingFruits: "Filling Fruits",
      toppingSauces: "Topping Sauces",
      decorSauces: "Decor Sauces",
      coldGlazes: "Cold Glazes",
      coffeeBarSauces: "Coffee Bar Sauces"
    },
    seeDetails: "See Details"
  },

  // Tea Page
  teaPage: {
    hero: {
      title: "Premium Tea Collection",
      subtitle: "Coming Soon",
      label: "TEA COLLECTION"
    },
    comingSoonText: "A new chapter in refined taste",
    description: "We are crafting an exceptional tea collection that honors tradition while embracing innovation. Stay tuned for something extraordinary."
  },

  // Machines Page
  machinesPage: {
    hero: {
      title: "Coffee & Tea Machines",
      subtitle: "Coming Soon",
      label: "EQUIPMENT"
    },
    comingSoonText: "Professional equipment for excellence",
    description: "We are curating a selection of premium coffee and tea machines designed for professionals who demand perfection in every cup."
  },

  // Chocolate Page
  chocolatePage: {
    hero: {
      title: "Premium Chocolate Collection",
      subtitle: "Coming Soon",
      label: "CHOCOLATE"
    },
    comingSoonText: "Indulgence redefined",
    description: "We are crafting an exquisite chocolate collection that blends artistry with exceptional taste. Stay tuned for something truly decadent."
  },

  // Elite Coffee Page
  eliteCoffee: {
    hero: {
      title: "Elite Coffee Collection",
      subtitle: "Coming Soon",
      label: "ELITE COFFEE"
    },
    comingSoonText: "The pinnacle of coffee artistry",
    description: "We are curating an exceptional elite coffee collection sourced from the world's most prestigious estates. Experience coffee beyond the ordinary."
  },

  // Elite Milkshake Page
  eliteMilkshake: {
    hero: {
      title: "Elite Milkshake Collection",
      subtitle: "Coming Soon",
      label: "ELITE MILKSHAKE"
    },
    comingSoonText: "Creamy indulgence elevated",
    description: "We are crafting a luxurious milkshake collection that redefines creamy decadence. Prepare for a taste experience unlike any other."
  },

  // Elite Tea Page
  eliteTea: {
    hero: {
      title: "Elite Tea Collection",
      subtitle: "Coming Soon",
      label: "ELITE TEA"
    },
    comingSoonText: "A timeless ritual perfected",
    description: "We are sourcing the world's rarest tea leaves to create a collection that honors centuries of tradition while embracing modern refinement."
  },

  // Elite Pods Page
  elitePods: {
    hero: {
      title: "Elite Coffee Pods",
      subtitle: "The finest single-serve espresso experience",
      label: "ELITE ESE 44MM PODS"
    },
    seeDetails: "See Details"
  },

  // Refresher Page
  refresherPage: {
    hero: {
      title: "Refresher",
      subtitle: "Vibrant and revitalizing beverage solutions",
      label: "REFRESHER COLLECTION"
    },
    seeDetails: "See Details"
  },

  // Ethiopian Page
  ethiopian: {
    hero: {
      title1: "Ethiopian",
      title2: "Elegance,",
      title3: "Refined in",
      title4: "Every Cup",
      description: "Born in the homeland of coffee,",
      description2: "crafted for those who appreciate heritage, aroma, and luxury.",
      cta: "Discover the Depth of Flavor"
    },
    features: {
      origin: "ETHIOPIAN ORIGIN",
      roasted: "ROASTED COFFEE",
      weight: "1 kg NET WEIGHT",
      gift: "LUXURY GIFT PRESENTATION",
      heritage: "PREMIUM HERITAGE"
    },
    origin: {
      title1: "The Heart of",
      title2: "Ethiopia",
      description: "From the birthplace of coffee, Lucendo Elite Ethiopian offers a distinguished character shaped by high altitudes, fertile soil, and generations of craftsmanship."
    },
    taste: {
      label: "TASTE PROFILE",
      richAroma: {
        title: "RICH AROMA",
        description: "Floral and inviting"
      },
      smoothBody: {
        title: "SMOOTH BODY",
        description: "Silky and balanced"
      },
      elegantFinish: {
        title: "ELEGANT FINISH",
        description: "Clean and lingering"
      },
      refinedRoast: {
        title: "REFINED ROAST",
        description: "Crafted for depth and purity"
      }
    },
    gift: {
      title1: "Crafted for",
      title2: "Exceptional Gifting",
      description: "Presented in a premium gift set that reflects the elegance within."
    },
    closing: {
      title1: "More Than Coffee.",
      title2: "It Is a Legacy.",
      description: "Lucendo Elite Ethiopian is a celebration of origin, craftsmanship, and timeless luxury."
    }
  },

  // Colombian Page
  colombian: {
    hero: {
      title: "COLOMBIAN",
      subtitle: "ROASTED COFFEE BEANS",
      tagline: "Fresh Origin. Refined Luxury.",
      description: "Single Origin Colombian coffee, crafted for those who appreciate exceptional quality and timeless refinement in every cup."
    },
    features: {
      singleOrigin: "SINGLE ORIGIN COLOMBIA",
      arabica: "100% ARABICA",
      roasted: "ROASTED COFFEE BEANS",
      weight: "1 kg e",
      madeInItaly: "MADE IN ITALY"
    },
    origin: {
      label: "OUR ORIGIN",
      title1: "From the Heart of",
      title2: "Colombia's Highlands",
      paragraph1: "Our beans come from Colombia's most renowned high-altitude regions, where rich volcanic soil, ideal climate, and generations of expertise create coffee of extraordinary quality.",
      paragraph2: "Every harvest reflects a deep respect for nature, tradition, and the pursuit of perfection."
    },
    taste: {
      label: "TASTE PROFILE",
      balancedAroma: {
        title: "BALANCED AROMA",
        description: "Rich and inviting with delicate fruity notes."
      },
      smoothBody: {
        title: "SMOOTH BODY",
        description: "Velvety and well-rounded with depth."
      },
      elegantFinish: {
        title: "ELEGANT FINISH",
        description: "Clean, lingering, and beautifully refined."
      },
      premiumRoast: {
        title: "PREMIUM ROAST",
        description: "Expertly roasted to highlight true character."
      }
    },
    closing: {
      title1: "Timeless Luxury.",
      title2: "Perfected in Every Bean.",
      description: "Lucendo Elite Colombian is more than coffee — It is a celebration of origin, craftsmanship, and the refined moments that matter."
    }
  }
};